import styled from "@emotion/styled";

import { SubscriptionWidget } from "~/components/posties/subscription-widget";

export const Container = styled.div`
  scroll-margin-top: 66px;

  padding-block: 40px;
  padding-inline: 0;

  ${props => props.theme.breakpoints.up("desktop")} {
    scroll-margin-top: 100px;

    padding-block: 64px;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  background-image: linear-gradient(#e3f7ff calc(100% - 20.25vw / 2), transparent 0%);

  overflow: hidden;
`;

export const StyledSubscriptionWidget = styled(SubscriptionWidget)`
  z-index: 1;

  padding-block-end: 16px;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding: 0;
  }
`;
